import { CropperPosition } from 'ngx-image-cropper';

class CroppedPos implements CropperPosition {
    public x1: number;
    public y1: number;
    public x2: number;
    public y2: number;
}

class OriginalImages {
    public selfie: any;
    public front: any;
    public back: any;
    public selfiePosition = new CroppedPos();
    public frontPosition = new CroppedPos();
    public backPosition = new CroppedPos();
}

class Images {
    public selfie: String;
    public front: String;
    public back: String;
}

export class Optin {
    public images: Images = new Images();
    public originalImages: OriginalImages = new OriginalImages();
}
